import { useQuery } from "@tanstack/react-query";
import { trpc } from "@/utils/trpc";

export const useBreadcrumbData = (dynamicIds: {
  site?: string;
  worker?: string;
  entrance?: string;
  template?: string;
  form?: string;
  signIn?: string;
}) => {
  const site = useQuery({
    ...trpc.getSite.queryOptions({ id: dynamicIds.site ?? "" }),
    enabled: Boolean(dynamicIds.site),
  });

  const worker = useQuery({
    ...trpc.getWorkerProfile.queryOptions({ id: dynamicIds.worker ?? "" }),
    enabled: Boolean(dynamicIds.worker),
  });

  const entrance = useQuery({
    ...trpc.getEntrancePublic.queryOptions({ id: dynamicIds.entrance ?? "" }),
    enabled: Boolean(dynamicIds.entrance),
  });

  const template = useQuery({
    ...trpc.forms.getTemplateById.queryOptions({
      templateId: dynamicIds.template ?? "",
    }),
    enabled: Boolean(dynamicIds.template),
  });

  const form = useQuery({
    ...trpc.forms.getById.queryOptions({
      id: dynamicIds.form ?? "",
    }),
    enabled: Boolean(dynamicIds.form),
  });

  const signIn = useQuery({
    ...trpc.getSignIn.queryOptions({ signInId: dynamicIds.signIn ?? "" }),
    enabled: Boolean(dynamicIds.signIn),
  });

  return {
    site,
    worker,
    entrance,
    template,
    form,
    signIn,
  };
};
